import { mediumFont, theme } from "../../../utils/styles";

const timeAnalysisStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 184px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    my: 3,
    maxWidth: "1750px",
    width: "100%",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 204px)",
    },
    [theme.breakpoints.down("md")]: {
      my: 2,
      height: "calc(100vh - 209px)",
    },
    [theme.breakpoints.down("sm")]: {
      my: 3,
    },
  },
  subBox: {
    p: 3,
    pt: 1.5,
    height: "calc(100vh - 222px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 242px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 247px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 229px)",
      p: 1,
    },
  },
  scrollStyle: {
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 220px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 235px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 222px)",
    },
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "45px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "35px",
    },
  },

  // Content area
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    pt: 2,
  },

  // Icon + title card
  iconCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1.5,
    background:
      "linear-gradient(135deg, rgba(144,83,246,0.15) 0%, rgba(94,117,255,0.1) 50%, rgba(44,241,223,0.08) 100%)",
    border: "1px solid rgba(144, 83, 246, 0.3)",
    borderRadius: "24px",
    px: { xs: 3, sm: 8 },
    py: 4,
    width: "100%",
    maxWidth: "520px",
    boxShadow:
      "0 0 40px rgba(144, 83, 246, 0.12), inset 0 1px 0 rgba(255,255,255,0.08)",
  },
  iconCircle: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, #9053F6 0%, #5E75FF 55%, #2CF1DF 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 8px 24px rgba(144, 83, 246, 0.45)",
    mb: 0.5,
  },
  cardTitle: {
    color: "#FFFFFF",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "22px",
    textAlign: "center",
    letterSpacing: "0.5px",
  },
  cardSubtitle: {
    color: "rgba(255,255,255,0.55)",
    fontSize: "14px",
    textAlign: "center",
    lineHeight: 1.6,
    maxWidth: "360px",
  },

  // Divider
  divider: {
    width: "100%",
    maxWidth: "520px",
    borderColor: "rgba(255,255,255,0.08)",
  },

  // Profile selector section
  selectorSection: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    maxWidth: "520px",
  },
  selectorLabelRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  selectorIcon: {
    color: "rgba(144, 83, 246, 0.9)",
    fontSize: "20px",
  },
  selectorLabel: {
    color: "rgba(255,255,255,0.8)",
    fontSize: "14px",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    letterSpacing: "0.3px",
  },
  autoComplete: {
    width: "100%",
    "& .MuiAutocomplete-input": {
      color: "#FFFFFF",
    },
    "& .MuiInputBase-root": {
      borderRadius: "14px",
      background: "rgba(255, 255, 255, 0.05)",
      backdropFilter: "blur(8px)",
      border: "1px solid rgba(144, 83, 246, 0.35)",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        borderColor: "rgba(144, 83, 246, 0.6)",
        boxShadow: "0 0 0 3px rgba(144,83,246,0.08)",
      },
      "&.Mui-focused": {
        borderColor: "rgba(144, 83, 246, 0.8)",
        boxShadow: "0 0 0 3px rgba(144,83,246,0.15)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiAutocomplete-endAdornment .MuiSvgIcon-root": {
      color: "rgba(255,255,255,0.5)",
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "rgba(255,255,255,0.5)",
    },
  },

  // Download section
  downloadSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1.5,
    width: "100%",
  },
  /**
   * A grid rather than a flex row: every cell is the same width and every
   * button stretches to the same height, so a label that wraps onto two lines
   * no longer leaves its neighbours sitting short. The column count steps down
   * with the viewport instead of squeezing five buttons into any width.
   */
  downloadButtonsRow: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, minmax(0, 1fr))",
      md: "repeat(3, minmax(0, 1fr))",
      lg: "repeat(5, minmax(0, 1fr))",
    },
    gap: { xs: 1.5, sm: 2 },
    width: "100%",
  },
  downloadButtonWrapper: {
    display: "flex",
    width: "100%",
    minWidth: 0,
    "& button": {
      width: "100%",
      // Fills the grid cell, which is what keeps the row of buttons level.
      height: "100%",
      // CustomButton asks for 180px; in the narrow cells that would overflow
      // the grid instead of letting the label wrap.
      minWidth: 0,
      borderRadius: "14px !important",
      px: 1.5,
      py: "12px",
      fontSize: "14px",
      letterSpacing: "0.3px",
      background:
        "linear-gradient(90deg, #9053F6 0%, #5E75FF 55%, #2CF1DF 100%) !important",
      boxShadow: "0 6px 20px rgba(144, 83, 246, 0.4) !important",
      transition: "opacity 0.2s ease, box-shadow 0.2s ease !important",
      "&:hover": {
        opacity: 0.9,
        boxShadow: "0 8px 28px rgba(144, 83, 246, 0.6) !important",
      },
      "&:disabled": {
        background: "rgba(255,255,255,0.08) !important",
        boxShadow: "none !important",
        color: "rgba(255,255,255,0.3) !important",
      },
    },
  },
  downloadButton: {
    width: "100%",
    minHeight: "50px",
  },
  /** Shared by every download button, so the five labels sit identically. */
  downloadButtonLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    width: "100%",
    textAlign: "center",
    lineHeight: 1.3,
    wordBreak: "break-word",
    "& .MuiSvgIcon-root": { flexShrink: 0 },
  },
  hintText: {
    color: "rgba(255,255,255,0.35)",
    fontSize: "12px",
    textAlign: "center",
    letterSpacing: "0.2px",
  },

  // Reports table section
  tableSection: {
    width: "100%",
    mt: 2,
  },
  tableSectionTitle: {
    color: "rgba(255,255,255,0.8)",
    fontSize: "14px",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    letterSpacing: "0.3px",
    mb: 1.5,
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    border: "1px solid rgba(255,255,255,0.2)",
    borderRadius: "8px",
    overflow: "hidden",
  },
  headerCell: {
    backgroundColor: "rgba(144, 83, 246, 0.4)",
    border: "1px solid rgba(255,255,255,0.2)",
    color: "#FFFFFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "13px",
    whiteSpace: "nowrap",
  },
  dataCell: {
    backgroundColor: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "rgba(255,255,255,0.85)",
    textAlign: "center",
    fontSize: "13px",
  },
  actionCell: {
    backgroundColor: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.1)",
    textAlign: "center",
  },
  noDataRow: {
    backgroundColor: "rgba(255,255,255,0.02)",
  },
  noDataCell: {
    border: "1px solid rgba(255,255,255,0.1)",
    color: "rgba(255,255,255,0.4)",
    textAlign: "center",
    fontSize: "13px",
    py: 3,
  },
} as const;

export default timeAnalysisStyles;
